import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroContactForm.MainInformation', {
    paymentDate: 'Payment date',
    paymentDatePlaceholder: 'Enter date',
    bankAccountLabel: 'Bank account',
    bankAccountPlaceholder: 'Select bank account',
    narrativeLabel: 'Narrative',
    narrativePlaceholder: 'Enter narrative',
    detailsLabel: 'Details',
    detailsPlaceholder: 'Enter details',
    particularsLabel: 'Particulars',
    particularsPlaceholder: 'Enter particulars',
    codeLabel: 'Code',
    codePlaceholder: 'Enter code',
    referenceLabel: 'Reference',
    referencePlaceholder: 'Enter reference',
});
